// authReducer.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  user: { accessToken: null },
  loading: false,
  preAuthUser: null,
  error: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loadingStart: (state, action) => {
      state.loading = true;
    },
    loadingStop: (state, action) => {
      state.loading = false;
    },
    setUser: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    updateToken: (state, action) => {
      state.user.accessToken = action.payload;
    },
    setPreAuthUser: (state, action) => {
      state.isLoggedIn = false;
      state.preAuthUser = action.payload;
      state.loading = false;
      state.error = null;
    },
    setAuthFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = { accessToken: null };
      state.loading = false;
      state.error = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadingStart,
  loadingStop,
  setUser,
  setAuthFailure,
  setPreAuthUser,
  logout,
  updateToken
} = authSlice.actions;

export default authSlice.reducer;
